<sm-svg-loader *ngIf="loader"></sm-svg-loader>

<!-- placeholder -->
<div class="dashboard_new" *ngIf="!loader && todaysBookingData.length == 0">
  <mat-card>
    <div class="upload_sectio">
      <div class="icm_img">
        <img src="./assets/images/today-appointments.png" />
      </div>
      <mat-card-title>See today's appointments and status</mat-card-title>
      <mat-card-content
        >Stay informed about latest appointments in real time. Ensure that
        customers are attended to promptly and that any special requests or
        preferences are accommodated.
      </mat-card-content>
      <!-- <div class="watch_vc_btn">
             <button mat-stroked-button color="primary" (click)="openvideo()">
                <mat-icon>smart_display</mat-icon>
                Watch video
             </button>
          </div> -->
    </div>
  </mat-card>
</div>

<!-- with data -->
<div class="today_booking_card" *ngIf="!loader && todaysBookingData.length > 0">
  <mat-card>
    <div class="vier_tht">
      <div class="heading_ot">
        <h3>Today's activity</h3>
      </div>
      <div class="view_all_btn" *ngIf="todaysBookingData[0].total_count > 4">
        <a (click)="openAllTodaysBookings()">{{
          todaysBookingData[0].total_count > 4
            ? "View all " + todaysBookingData[0].total_count
            : "View details"
        }}</a>
      </div>
    </div>
    <!--  -->
    <div
      class="list_yy"
      *ngFor="let item of todaysBookingData"
      (click)="bookingDetails(item)"
    >
      <div class="bookign_img">
        <img
          [src]="item.customer_thumb_image"
          onerror="this.src='../../../../../../assets/images/user-avatar.svg'"
          alt=""
        />
      </div>
      <div class="booking_heading">
        <h3>
          {{ item.customer_name ? item.customer_name : "Guest Customer" }}
        </h3>
        <p>
          {{
            item.customer_phone
              ? item.country_code + " " + item.customer_phone
              : "No phone info"
          }}
        </p>
      </div>
      <div class="booking_heading">
        <h3>
          {{ item.business_name ? item.business_name : "No business info" }}
        </h3>
        <p *ngIf="item.booking_type == 0 && item.data_type == 1">
          {{
            item.booking_address && item.booking_address != '' && item.booking_address != 'null' 
              ? "Visit: " + item.booking_address.address_line
              : "No address info"
          }}
        </p>
        <p *ngIf="item.booking_type == 0 && item.data_type == 2">
          {{
            item.booking_address
              ? "Visit: " + item.booking_address
              : "No address info"
          }}
        </p>
        <p *ngIf="item.booking_type != 0">
          {{
            item.business_address
              ? item.business_address
              : "No address info"
          }}
        </p>
      </div>
      <div class="booking_heading">
        <h3 *ngIf="item.data_type == 1 || item.data_type == 2">
          {{ item.booking_start_time }} - {{ item.booking_end_time }}
        </h3>
        <h3 *ngIf="item.data_type == 3">{{ item.time }}</h3>
        <p>{{ item.bookingType ? item.bookingType : "N/A" }}</p>
      </div>
      <div
        class="status_heading"
        [class.new-booking]="
          ((item.appointment_status == 0 ||
            item.appointment_status == 1 ||
            item.appointment_status == 2) &&
            item.data_type == 1) ||
          (item.appointment_status == 1 &&
            !item.session_status &&
            item.data_type == 2) ||
          (item.appointment_status == 1 && item.data_type == 3)
        "
        [class.under-process]="
          ((item.appointment_status == 3 ||
            item.appointment_status == 7 ||
            item.appointment_status == 9) &&
            item.data_type == 1) ||
          (item.appointment_status == 1 &&
            (item.session_status == 2 || item.session_status == 1) &&
            item.data_type == 2) ||
          (item.appointment_status == 2 && item.data_type == 3) ||
          (item.appointment_status == 3 && item.data_type == 3)
        "
        [class.completed]="
          (item.appointment_status == 4 && item.data_type == 1) ||
          (item.appointment_status == 1 &&
            item.session_status == 3 &&
            item.data_type == 2) ||
          (item.appointment_status == 5 && item.data_type == 3)
        "
        [class.cancelled]="
          ((item.appointment_status == 6 || item.appointment_status == 8) &&
            item.data_type == 1) ||
          (item.appointment_status == 0 && item.data_type == 2) ||
          (item.appointment_status == 4 && item.data_type == 3)
        "
        [class.confirmed]="item.appointment_status == 5 && item.data_type == 1"
      >
        <div class="booking_done">
          <p>{{ item.bookingStat ? item.bookingStat : "--" }}</p>
          <p
            style="
              font-size: 12px;
              color: #1d1d1d;
              margin: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 5px;
              width: 65px;
            "
          >
            {{ item.employee_name ? item.employee_name : "---" }}
          </p>
        </div>

        <!-- icon alert -->
        <div class="booking_block">
          <mat-icon>arrow_forward</mat-icon>
        </div>
        <!-- icon alert -->
      </div>
    </div>

    <div
      class="list_yy"
      style="height: 61px"
      *ngFor="let item of repeatArray"
    ></div>
    <!-- <div class="list_yy">
        <div class="bookign_img">
        <img src="https://img.freepik.com/free-photo/stylish-handsome-indian-man-tshirt-pastel-wall_496169-1571.jpg" alt=""/>
        </div>
        <div class="booking_heading">
            <h3>Suraj Das</h3>
            <p>+91 74364694574</p>
        </div>
        <div class="booking_heading">
            <h3>Abc Beauty</h3>
            <p>Durgapur, WB</p>
        </div>
        <div class="booking_heading">
            <h3>3:00 PM - 4:00PM</h3>
            <p>Shop booking</p>
        </div>
        <div class="status_heading">
         <p class="colorstatus">Completed</p>
        </div>
      </div>
      <div class="list_yy" >
        <div class="bookign_img">
        <img src="https://images.pexels.com/photos/938639/pexels-photo-938639.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" alt=""/>
        </div>
        <div class="booking_heading">
            <h3>Rahul Rathod</h3>
            <p>+91 74364694574</p>
        </div>
        <div class="booking_heading">
            <h3>Abc Beauty</h3>
            <p>Asansol, WB</p>
        </div>
        <div class="booking_heading">
            <h3>3:00 PM - 4:00PM</h3>
            <p>Shop booking</p>
        </div>
        <div class="status_heading">
         <p>In-progress</p>
        </div>
      </div>
      
      <div class="list_yy">
        <div class="bookign_img">
        <img src="https://img.freepik.com/free-photo/stylish-handsome-indian-man-tshirt-pastel-wall_496169-1571.jpg" alt=""/>
        </div>
        <div class="booking_heading">
            <h3>Rahul Rathod</h3>
            <p>+91 74364694574</p>
        </div>
        <div class="booking_heading">
            <h3>Abc Beauty</h3>
            <p>Durgapur, WB</p>
        </div>
        <div class="booking_heading">
            <h3>3:00 PM - 4:00PM</h3>
            <p>Shop booking</p>
        </div>
        <div class="status_heading">
         <p class="colorstatus">Completed</p>
        </div>
      </div> -->
  </mat-card>
</div>
